import HttpError from 'core/exceptions/httpError';

export default class HttpNotFound extends HttpError {}
